var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconClimbing = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 1)",
    fill: "#1A202C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.683 19.51 7.71 18.132l-.81-.106L8.099 22.3a1.14 1.14 0 0 0 2.194-.615l-.61-2.176z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.146,
    cy: 4.637,
    r: 1.968
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.645 17.686-3.52-2.457a1.14 1.14 0 0 0-.504-.195l-4.502-.588c.188.384.761 1.298.055 2.305l3.875.506 3.292 2.298a1.14 1.14 0 0 0 1.304-1.869z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.523 0H5.883a.224.224 0 0 0-.12.413l.652.414-.074 4.272L4.57 7.062l-2.353.24A1.33 1.33 0 0 0 1.03 8.762l.07.676 1.06-1.08-2.03 3.37a.95.95 0 0 0-.033.896L1.799 16.1a.95.95 0 1 0 1.705-.836l-1.446-2.95L3.88 9.195l-.79 2.821-.059.209.975 1.988 2.616-.23-.585-5.711 1.955-2.167a.95.95 0 0 0 .244-.623l.047-3.426c.297.276.519.627.639 1.02l.798 2.615c.108.354.299.676.557.94l2.738 2.806c.45.462.688 1.09.655 1.734l-.219 4.284c-.022.436.08.87.295 1.252l1.903 3.383c.229.406.575.734.993.94l2.67 1.318a.477.477 0 0 0 .689-.427V.477A.477.477 0 0 0 19.523 0z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClimbing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-climbing.f211f91b.svg";
export { ForwardRef as ReactComponent };